import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/devteam/haritweg/frontend/src/app/[locale]/home-client.js");
